import { agroApi } from "../../../../redux/api/api";
import { AgrCooperativesEndpoints } from "./types";

export const agrCooperativesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getAgrCooperativesByYear: builder.query<
      AgrCooperativesEndpoints['getAgrCooperativesByYear']['response'],
      AgrCooperativesEndpoints['getAgrCooperativesByYear']['request']
    >({
      query: (filter) => ({
        url: "/departments/mechanization/agricultural-cooperatives/analytical-data",
        method: "GET",
        // params: { year: Number(filter.year) },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetAgrCooperativesByYearQuery } = agrCooperativesApi;
